/**
 * Textos en castellano del modelo Nevora (FASE 2): negocios, notas, resultados, pipeline,
 * agenda, panel, ajustes e importación. Se fusiona en i18nProvider.ts junto a es.ts.
 * `resources.<recurso>.fields.<columna>` da la etiqueta automática de los inputs.
 */
export const mensajesNegociosEs = {
  resources: {
    negocios: {
      name: "Negocio |||| Negocios",
      fields: {
        nombre: "Nombre del negocio",
        sector: "Sector",
        direccion: "Dirección",
        telefono: "Teléfono",
        web: "Web",
        persona_contacto: "Persona de contacto",
        cargo_contacto: "Cargo",
        es_decisor: "¿Es quien decide?",
        email: "Email de contacto",
        origen: "Origen",
        asignado_a: "Asignado a",
        etapa: "Etapa",
        ultimo_contacto: "Último contacto",
        siguiente_paso: "Siguiente paso",
        fecha_siguiente_paso: "Fecha del siguiente paso",
        hora_siguiente_paso: "Hora (opcional)",
        fecha_reunion: "Consultoría (fecha y hora)",
        fecha_presentacion: "Presentación (fecha y hora)",
        fecha_vuelta: "Fecha de vuelta",
        no_llamar: "No volver a contactar",
        valor_estimado: "Valor estimado (€)",
        importe_total: "Importe aceptado (€)",
        intentos: "Intentos",
        created_at: "Fecha de alta",
        creado_por: "Creada por",
        place_id: "Google place_id",
      },
    },
    notas: {
      name: "Nota |||| Notas",
      fields: {
        fecha: "Fecha",
        canal: "Canal",
        resultado: "Resultado",
        reaccion: "Reacción",
        objecion: "Objeción",
        texto: "Nota",
        autor: "Autor",
      },
    },
  },
  nevora: {
    nav: {
      mas: "Más",
      importar: "Importar CSV",
      comisiones: "Comisiones",
      nevora: "Nevora",
      equipo: "Equipo",
      sin_asignar: "Sin asignar",
      colaboraciones: "Colaboraciones",
      grupo_equipo: "Equipo comercial",
      resumen: "Resumen de llamadas",
      mis_comisiones: "Mis comisiones",
      informe: "Informe mensual",
    },
    comun: {
      sin_resultados: "Sin resultados",
    },
    // Fases anteriores a S8: solo para el historial (notas antiguas).
    fases: {
      nuevo: "Nuevo",
      seguimiento: "Seguimiento",
      reunion_agendada: "Reunión agendada",
      propuesta_enviada: "Propuesta enviada",
      firmado: "Firmado",
      cobrado: "Cobrado",
      no_contesta: "No contesta",
      no_interesado: "No interesado",
      largo_plazo: "Largo plazo",
    },
    // Catálogo cerrado de etapas (S8, 02/10/2026): mismos nombres que public.etapas.
    etapas: {
      nuevo: "Lead nuevo",
      en_conversacion: "En conversación",
      consultoria_agendada: "Consultoría agendada",
      no_show: "No show",
      esperando_info: "Esperando info del cliente",
      preparando_propuesta: "Preparando propuesta",
      propuesta_lista: "Propuesta lista · pedir fecha",
      presentacion_agendada: "Presentación agendada (videollamada)",
      pensandolo: "Se lo tiene que pensar",
      aceptada: "Aceptada · contrato y factura",
      cobrado: "Cobrado",
      no_contesta: "No contesta",
      no_interesado: "No interesado",
      largo_plazo: "Largo plazo",
      arranque: "Arranque y DPA",
      desarrollo: "En desarrollo",
      produccion: "Puesta en producción",
      mantenimiento: "En mantenimiento",
      baja: "Baja",
    },
    embudos: {
      ventas: "Ventas",
      clientes: "Clientes",
    },
    origenes: {
      puerta_fria: "Puerta fría",
      extraccion: "Extracción",
      propio_comercial: "Propio del comercial",
      prospect: "Nevora Prospect",
      web: "Web",
    },
    canales: {
      llamada: "Llamada",
      visita: "Visita",
      email: "Email",
      whatsapp: "WhatsApp",
      videollamada: "Videollamada",
      otro: "Otro",
      web: "Formulario web",
    },
    resultados: {
      quiere_reunion: "Quiere reunión",
      interesado: "Interesado, falta confirmar fecha",
      ni_si_ni_no: "Ni sí ni no",
      no_contesta: "No contesta",
      no_interesa: "No le interesa",
      mas_adelante: "Ahora no, más adelante",
      no_se_presento: "No se presentó a la consultoría",
      no_quiere_contacto: "No quiere que le contactemos",
    },
    resultados_ayuda: {
      quiere_reunion: "Pasa a Consultoría agendada; la reunión va a la agenda",
      interesado:
        "Pasa a En conversación con la marca «Interesado» y fecha para confirmar la consultoría",
      ni_si_ni_no: "Pasa a En conversación con fecha del siguiente contacto",
      no_contesta: "Suma un intento; al último de Ajustes se aparca",
      no_interesa:
        "Pasa a No interesado; opcionalmente «no volver a contactar»",
      mas_adelante:
        "Pasa a Largo plazo y vuelve sola a esta etapa el día indicado",
      no_se_presento:
        "Pasa a No show para volver a agendarla. A la tercera, No interesado (sin comisión)",
      no_quiere_contacto:
        "Pasa a No interesado con «no volver a contactar» y entra en la lista de no contactar",
    },
    etapas_errores: {
      no_llamar:
        "Esta ficha tiene «no volver a contactar»: un administrador debe quitar la marca antes de reactivarla",
      ventas_a_clientes:
        "A Clientes se pasa registrando el cobro (etapa Cobrado)",
      clientes_a_ventas:
        "Un proyecto de Clientes no vuelve a Ventas: crea un proyecto nuevo",
      cobrado_sin_cobro:
        "A Cobrado se llega registrando el cobro (importe y fecha)",
      un_ventas: "Este cliente ya tiene un proyecto en Ventas",
      solo_ejecucion:
        "Esa etapa la llevan Jan y Robert: tú mueves la ficha hasta «Consultoría agendada»",
      no_show_con_boton:
        "A No show se pasa con «No se presentó», en el recuadro de la consultoría de la ficha: así se cuentan las veces",
    },
    // Hoja «Resultado de la presentación» (Robert, 02/10/2026)
    resultados_presentacion: {
      aceptada: "Aceptada",
      lo_pensara: "Se lo tiene que pensar",
      repropuesta: "Quiere repropuesta",
      no_interesa: "No le interesa",
    },
    resultados_presentacion_ayuda: {
      aceptada: "Pasa a Aceptada · contrato y factura",
      lo_pensara: "Pasa a Se lo tiene que pensar, con la fecha de su respuesta",
      repropuesta: "Vuelve a Preparando propuesta, con lo que quiere cambiar",
      no_interesa: "Pasa a No interesado, con el motivo",
    },
    resultados_visita: {
      quiere_reunion: "Quiere reunión",
      interesado: "Interesado, falta confirmar fecha",
      ni_si_ni_no: "Ni sí ni no",
      no_contesta: "No estaba el responsable / cerrado",
      no_interesa: "No le interesa",
      mas_adelante: "Ahora no, más adelante",
      no_se_presento: "No se presentó a la consultoría",
      no_quiere_contacto: "No quiere que le contactemos",
    },
    resultados_visita_ayuda: {
      quiere_reunion: "Pasa a Consultoría agendada; la reunión va a la agenda",
      interesado:
        "Pasa a En conversación con la marca «Interesado» y fecha para confirmar la consultoría",
      ni_si_ni_no: "Pasa a En conversación con fecha del siguiente contacto",
      no_contesta: "Cuenta como intento; al último de Ajustes se aparca",
      no_interesa:
        "Pasa a No interesado; opcionalmente «no volver a contactar»",
      mas_adelante:
        "Pasa a Largo plazo y vuelve sola a esta etapa el día indicado",
      no_se_presento:
        "Pasa a No show para volver a agendarla. A la tercera, No interesado (sin comisión)",
      no_quiere_contacto:
        "Pasa a No interesado con «no volver a contactar» y entra en la lista de no contactar",
    },
    // «He escrito» (WhatsApp o email), v1.1 tanda 1: los mismos cinco resultados con
    // etiquetas propias. Los resultados específicos («Información enviada»…) son la tanda 2.
    resultados_escrito: {
      quiere_reunion: "Ha respondido: quiere reunión",
      interesado: "Ha respondido: interesado, falta confirmar fecha",
      ni_si_ni_no: "Mensaje enviado, pendiente de respuesta",
      no_contesta: "Sin respuesta",
      no_interesa: "Ha respondido: no le interesa",
      mas_adelante: "Ha respondido: más adelante",
      no_se_presento: "No se presentó a la consultoría",
      no_quiere_contacto: "Ha respondido: no quiere que le contactemos",
    },
    resultados_escrito_ayuda: {
      quiere_reunion: "Pasa a Consultoría agendada; la reunión va a la agenda",
      interesado:
        "Pasa a En conversación con la marca «Interesado» y fecha para confirmar la consultoría",
      ni_si_ni_no:
        "Pasa a En conversación con fecha para revisar si ha contestado",
      no_contesta: "Cuenta como intento; al último de Ajustes se aparca",
      no_interesa:
        "Pasa a No interesado; opcionalmente «no volver a contactar»",
      mas_adelante:
        "Pasa a Largo plazo y vuelve sola a esta etapa el día indicado",
      no_se_presento:
        "Pasa a No show para volver a agendarla. A la tercera, No interesado (sin comisión)",
      no_quiere_contacto:
        "Pasa a No interesado con «no volver a contactar» y entra en la lista de no contactar",
    },
    buscador: {
      titulo: "Buscar ficha",
      placeholder: "Nombre, persona de contacto, teléfono o dirección…",
      ayuda:
        "Escribe al menos 2 letras. Busca en todas las fichas, también las aparcadas.",
      vacio: "Ninguna ficha coincide",
      con_descubiertos:
        "Incluir los descubiertos por Nevora Prospect (sin entregar)",
    },
    ajustes_etapas: {
      ayuda:
        "Las etapas de los embudos Ventas y Clientes y cómo se llega a cada una. Lista cerrada: solo cambia con una nueva versión de la app.",
      etapa: "Etapa",
      como: "Cómo se llega",
      quien: "Quién",
      quien_comercial: "Comercial",
      quien_ejecucion: "Jan y Robert",
      quien_ambos: "Cualquiera",
      aparcada: "aparcada",
      como_nuevo:
        "Al crear la ficha (a mano, CSV o Prospect). «No contesta» la deja aquí con un intento más.",
      como_en_conversacion: "Botón «Ni sí ni no» o a mano.",
      como_consultoria_agendada:
        "Botón «Quiere reunión» (con fecha y hora) o a mano.",
      como_no_show:
        "Botón «No se presentó» con la consultoría agendada. «Quiere reunión» la vuelve a agendar; a la tercera vez, No interesado.",
      como_esperando_info:
        "A mano tras la consultoría, cuando falta algo del cliente para preparar la propuesta.",
      como_preparando_propuesta:
        "A mano tras la consultoría. También la compra nueva de un cliente y «Quiere repropuesta».",
      como_propuesta_lista: "A mano, con la propuesta revisada por los dos.",
      como_presentacion_agendada:
        "A mano, con fecha y hora de la videollamada: sale en la agenda.",
      como_pensandolo:
        "Resultado de la presentación, con la fecha de su respuesta.",
      como_aceptada: "Resultado de la presentación.",
      como_cobrado:
        "Registrando el primer cobro (importe y fecha). Pasa sola a Clientes.",
      como_no_contesta:
        "Sola, al llegar a los intentos de Ajustes con «No contesta». O a mano.",
      como_no_interesado:
        "Botón «No le interesa» o resultado de la presentación, con motivo. O a mano.",
      como_largo_plazo:
        "Botón «Más adelante» (con fecha). Vuelve sola ese día a la etapa desde la que se aparcó.",
      como_arranque: "Sola, al registrar el cobro.",
      como_desarrollo: "A mano.",
      como_produccion: "A mano.",
      como_mantenimiento: "A mano.",
      como_baja: "A mano.",
    },
    completitud: {
      faltan: "Faltan datos: %{datos}",
      datos: {
        telefono: "teléfono",
        email: "email",
        persona_contacto: "persona de contacto",
      },
    },
    semaforo: {
      verde: "Al día",
      azul: "Reciente",
      amarillo: "Atención",
      naranja: "Se enfría",
      rojo: "Sin contacto",
      dias: "%{smart_count} día sin contacto |||| %{smart_count} días sin contacto",
    },
    negocios: {
      leads: "Leads",
      leads_ayuda:
        "Pendientes de llamar, en el orden en que conviene: primero lo que llega de la web y los reintentos que ya tocan; después los nuevos por prioridad. «No contesta» programa solo el siguiente intento.",
      todos: "Todos",
      aparcados: "Aparcados",
      tablero: "En el tablero",
      nueva_ficha: "Nueva ficha",
      ficha: "Ficha de negocio",
      cerrar_ficha: "Cerrar",
      cargando_ficha: "Cargando la ficha…",
      he_llamado: "He llamado",
      he_visitado: "He visitado",
      he_escrito: "He escrito",
      completar_ficha: "Completar ficha",
      nuevo_sector: "+ Crear sector…",
      nuevo_sector_pregunta: "Nombre del nuevo sector",
      sector_creado: "Sector «%{sector}» creado y seleccionado",
      llamar: "Llamar",
      mapa: "Ver en Google Maps",
      abrir_web: "Abrir web",
      buscar: "Buscar nombre, teléfono, contacto…",
      sin_leads:
        "No tienes leads pendientes. Los nuevos te llegan solos durante el día o te los asignan Jan o Robert.",
      sin_resultados: "No hay negocios con estos filtros",
      mas_datos: "Más datos",
      datos_contacto: "Contacto",
      seguimiento: "Seguimiento",
      historial: "Historial",
      intentos: "%{smart_count} intento |||| %{smart_count} intentos",
      sin_intentos: "Sin intentos",
      ultimo_contacto: "Último contacto",
      nunca: "Sin contactar",
      decisor: "Decide",
      no_decisor: "No decide",
      no_llamar: "No volver a contactar",
      web_ayuda: "Llegó por la web: %{fuente}",
      web_ayuda_sin_fuente: "Llegó por la web",
      sin_guardar_titulo: "¿Cerrar sin guardar?",
      sin_guardar_texto:
        "Has cambiado datos de la ficha y no los has guardado. Si cierras ahora, se pierden.",
      seguir_editando: "Seguir editando",
      cerrar_sin_guardar: "Cerrar sin guardar",
      sin_siguiente_paso: "Sin siguiente paso",
      cambiar_etapa: "Cambiar de etapa",
      reactivar: "Reactivar (vuelve a «%{etapa}»)",
      resultado_presentacion: "Resultado de la presentación",
      registrar_cobro: "Registrar cobro",
      nuevo_proyecto: "Nuevo proyecto (compra nueva)",
      borrar_confirmacion:
        "¿Borrar la ficha «%{nombre}» y todo su historial? No se puede deshacer.",
      creada: "Ficha creada",
      reclamada:
        "Ya estaba en el CRM, sin dueño (lo había encontrado Nevora Prospect): ahora es tuyo",
      guardada: "Ficha guardada",
      borrada: "Ficha borrada",
      sin_asignar: "Sin asignar",
      responsable: "Responsable",
      valor: "Valor estimado",
      etapa_cambiada: "Movida a «%{etapa}»",
      editar: "Editar ficha",
      alta_rapida_ayuda:
        "Solo el nombre es obligatorio. El resto se puede completar después.",
      vuelve_el: "Vuelve el %{fecha}",
      reunion_el: "Reunión: %{fecha}",
      paso_el: "%{paso} · %{fecha}",
      filtros: {
        etapa: "Etapa",
        sector: "Sector",
        origen: "Origen",
        asignado: "Asignado a",
        mios: "Solo los míos",
      },
    },
    resultado: {
      titulo: "Resultado del contacto",
      titulo_anotar: "Anotar el contacto",
      ayuda_anotar:
        "En esta etapa el contacto se anota con su siguiente paso; la tarjeta no se mueve.",
      titulo_presentacion: "Resultado de la presentación",
      fecha_respuesta: "¿Cuándo dará la respuesta?",
      cambios: "¿Qué quiere cambiar de la propuesta?",
      cambios_ayuda: "Queda en el historial para preparar la nueva",
      subtitulo: "%{nombre}",
      canal: "¿Cómo has contactado?",
      canal_escrito: "¿Por dónde has escrito?",
      esperar_respuesta: "Esperar respuesta",
      resultado: "¿Cómo ha ido?",
      fecha_reunion: "Fecha y hora de la reunión",
      // Jan y Robert, 13/10/2026: sin email no se agenda la consultoría.
      email_reunion: "Email del contacto",
      email_reunion_ayuda:
        "La ficha no tiene email y hace falta para la consultoría. Se guarda en la ficha.",
      fecha_siguiente_paso: "Fecha del siguiente contacto",
      paso_interesado: "Confirmar la fecha de la consultoría",
      paso_no_show: "Llamar para reagendar la consultoría",
      // 39: confirma la cita quien hace la consultoría; el setter se lo anuncia al cliente.
      aviso_consultor:
        "Dile al cliente que, antes de la reunión, le contactará quien hará la consultoría para presentarse y confirmarla.",
      importe_aceptado: "Importe aceptado (€)",
      importe_aceptado_ayuda:
        "El precio por el que se ha aceptado. De él salen las comisiones.",
      hora_siguiente_paso: "Hora del siguiente paso (opcional)",
      siguiente_paso: "Siguiente paso",
      siguiente_paso_ayuda:
        "Por ejemplo: «Enviar tarifa» o «Llamar al gerente»",
      fecha_vuelta: "¿Cuándo volvemos a intentarlo?",
      motivo: "¿Por qué no le interesa?",
      no_llamar: "Marcar «no volver a contactar»",
      nota: "Nota (opcional)",
      nota_ayuda: "Qué ha pasado, en una línea",
      detalles: "Reacción y objeción",
      reaccion: "Reacción",
      objecion: "Objeción",
      fecha_contacto: "Fecha del contacto",
      guardar: "Guardar",
      guardando: "Guardando…",
      guardado: "Contacto registrado: %{etapa}",
      aparcada: "Aparcada en «No contesta» tras %{intentos} intentos",
      errores: {
        no_llamar: "Esta ficha está marcada como «no volver a contactar»",
        falta_fecha_reunion: "Indica la fecha y hora de la reunión",
        falta_fecha_siguiente_paso: "Indica la fecha del siguiente contacto",
        falta_fecha_vuelta: "Indica la fecha de vuelta",
        falta_resultado: "Elige un resultado",
        falta_motivo: "Elige el motivo",
        falta_interes: "Elige el nivel de interés: frío, tibio o caliente",
        falta_importe: "Pon el importe por el que se ha aceptado",
        falta_email: "Escribe un email válido: hace falta para la consultoría",
        email_repetido:
          "Ese email ya está en otra ficha del CRM. Consúltalo con Jan o Robert.",
        solo_anotar:
          "En esta etapa el contacto se anota sin resultado: la tarjeta se mueve a mano",
        no_presentacion:
          "El resultado de la presentación se registra en «Presentación agendada» o «Se lo tiene que pensar»",
        falta_fecha_respuesta: "Indica cuándo dará la respuesta",
        falta_cambios: "Escribe qué quiere cambiar de la propuesta",
        sin_consultoria:
          "«No se presentó» se registra con la consultoría agendada",
      },
    },
    notas: {
      nueva: "Añadir nota",
      texto: "Escribe una nota…",
      guardar: "Guardar nota",
      guardada: "Nota guardada",
      vacio: "Todavía no hay notas",
      sin_texto: "(sin texto)",
      nota_libre: "Nota",
      paso_a: "→ %{etapa}",
      cambio_etapa: "Cambio de etapa",
      editar: "Editar",
      editar_ayuda:
        "Solo se corrigen el texto y el canal. Si el resultado estaba mal, mueve la tarjeta.",
      guardar_cambios: "Guardar cambios",
      cancelar: "Cancelar",
      editada: "Editada por %{quien} · %{fecha}",
      editada_sin_quien: "Editada · %{fecha}",
      corregida: "Nota corregida",
    },
    ficha: {
      proximo_paso: "Próximo paso",
      secciones: {
        informacion: "Información",
        seguimiento: "Seguimiento",
        proyectos: "Proyectos y cobros",
        historial: "Historial",
      },
      ayuda_guardar:
        "«He llamado», «He visitado» y «He escrito» registran cualquier contacto, no solo el primero. Los cambios del formulario se guardan con «Guardar».",
      no_llamar_ayuda:
        "La persona ha pedido que no la contactemos. Bloquea llamadas, visitas y mensajes, también en Prospect. Solo un administrador puede quitarlo.",
      no_llamar_solo_admin:
        "Solo un administrador puede quitar la marca «no volver a contactar»",
      campana_prospect:
        "Nevora Prospect tiene una campaña de correo en marcha con este negocio.",
      sacar_de_campana: "Sacar de la campaña de email",
      sacar_de_campana_confirmar:
        "¿Sacar este negocio de la campaña de email de Nevora Prospect? No se le enviará ningún correo más de la campaña.",
      sacar_de_campana_hecho: "Fuera de la campaña de email",
      sacar_de_campana_error:
        "No se pudo sacar de la campaña: inténtalo otra vez",
      la_llevan_jan_robert:
        "Desde la consultoría esta ficha la llevan Jan y Robert. Aquí ves cómo avanza.",
      // 37: el setter tras la consultoría y el consultor ven la ficha sin poder cambiarla.
      solo_lectura:
        "Solo lectura: los datos de esta ficha los cambia su responsable. Aquí ves cómo avanza.",
      // 36 (Robert, 20/10/2026)
      no_shows: "No se presentó: %{n} de %{max}",
      cita_confirmada: "Cita confirmada",
      // 42 (Robert, 26-28/10/2026): el consultor.
      sin_respuesta: "Sin respuesta",
      quitar_sin_respuesta: "Quitar «sin respuesta»",
      sin_respuesta_ayuda:
        "El cliente no ha contestado al intentar confirmar. La cita sigue: hay quien no contesta y se presenta.",
      sin_respuesta_hecho: "Marcada «sin respuesta» (la cita sigue)",
      sin_respuesta_quitada: "Quitada la marca «sin respuesta»",
      meet: "Meet",
      meet_copiar: "Copiar",
      meet_copiado: "Enlace de Meet copiado",
      meet_no_copiado: "No se ha podido copiar: selecciona el enlace y cópialo",
      otra_hora: "El cliente pide otra hora",
      otra_hora_que:
        "¿Qué día y hora le van bien? (le llega a quien la agendó y a Jan y Robert)",
      otra_hora_enviar: "Avisar",
      otra_hora_hecho: "Avisado: quien la agendó la moverá",
      d8_pregunta: "¿Qué día y a qué hora mandará su información?",
      d8_guardar: "Esperando info del cliente",
      info_cliente: "Su información, para el",
      nota_consultor: "Añadir nota",
      nota_consultor_guardar: "Guardar nota",
      nota_consultor_hecha: "Nota guardada",
      nota_canal: "Canal",
      nota_canal_whatsapp: "WhatsApp",
      nota_canal_llamada: "Llamada",
      nota_canal_email: "Email",
      nota_canal_otro: "Otro",
      confirmar_cita: "Marcar cita confirmada",
      confirmar_cita_ayuda:
        "La marca quien hace la consultoría, cuando el cliente le confirme la cita (el día antes le llega el aviso).",
      desconfirmar_cita: "Quitar «confirmada»",
      cita_confirmada_hecho: "Cita marcada como confirmada",
      cita_desconfirmada_hecho: "Quitada la marca «confirmada»",
      consultores: "Quién hace la consultoría",
      consultores_ayuda:
        "Uno o varios. El primero se queda la ficha cuando la consultoría esté hecha; quien la agendó sigue cobrando su comisión.",
      consultores_sin: "Sin elegir: la hacen Jan o Robert",
      // 39 (Robert, 23/10/2026)
      agendada_por: "Agendada por",
      escribir_a: "Escribir a %{nombre}",
      resultado_consultoria: "Resultado de la consultoría",
      consultoria_se_hizo: "Se hizo",
      consultoria_no_se_presento: "No se presentó",
      se_hizo_titulo: "La consultoría se hizo",
      se_hizo_pregunta: "¿Cómo sigue?",
      se_hizo_guardar: "Guardar",
      se_hizo_hecho: "Consultoría hecha: %{etapa}",
      no_se_presento_hecho:
        "Apuntado: no se presentó. El setter tiene «Llamar para reagendar» para hoy.",
      consultores_cambiar: "Elegir",
      consultores_guardar: "Guardar",
      consultores_cancelar: "Cancelar",
      consultores_guardados: "Guardado quién hace la consultoría",
      no_contactar_titulo: "En la lista de no contactar",
      no_contactar_desde: "Desde el %{fecha}: %{motivo}",
      no_contactar_sin_motivo: "sin motivo anotado",
      no_contactar_prospect: "lo añadió Nevora Prospect",
      no_contactar_crm: "se marcó en el CRM",
      errores: {
        falta_fecha_paso: "Si hay siguiente paso, indica su fecha",
        falta_fecha_reunion: "Indica la fecha y hora de la reunión",
        falta_fecha_presentacion: "Indica la fecha y hora de la presentación",
        falta_fecha_vuelta: "Indica la fecha de vuelta",
      },
    },
    proyectos: {
      titulo: "Proyectos de este cliente",
      ventas: "Ventas",
      clientes: "Clientes",
      principal: "en esta ficha",
      ver: "Ver",
      nombre: "Nombre del proyecto (opcional)",
      nombre_ayuda: "Por ejemplo: «Web nueva 2027»",
      nuevo_ayuda:
        "La compra nueva de un cliente entra en Ventas · Preparando propuesta.",
      crear: "Crear proyecto",
      creado: "Proyecto creado en «Preparando propuesta»",
      cobros: "Cobros",
      cobro_n: "Cobro %{n}",
      sin_cobros: "Sin cobros registrados",
      total_cobrado: "Cobrado: %{importe}",
      importe_total: "Importe aceptado: %{importe}",
      sin_iva: "sin IVA",
    },
    cobro: {
      titulo_primero: "Registrar el cobro (primer 50 %)",
      titulo_otro: "Registrar otro cobro",
      ayuda_primero:
        "Al guardarlo, el proyecto pasa a Clientes · Arranque y DPA.",
      ayuda_otro: "El proyecto se queda en su etapa de Clientes.",
      importe_total: "Importe total del proyecto, sin IVA (€)",
      importe: "Importe cobrado: base imponible sin IVA (€)",
      concepto: "¿De qué es este cobro?",
      concepto_proyecto: "Proyecto",
      concepto_mantenimiento: "Mantenimiento",
      comision_ayuda:
        "La comisión del setter (5 % de la base sin IVA) la calcula el CRM sola. El mantenimiento no lleva comisión.",
      fecha: "Fecha de cobro",
      nota: "Nota (opcional)",
      guardar: "Registrar cobro",
      guardado: "Cobro registrado",
      guardado_clientes: "Cobro registrado: el proyecto pasa a Clientes",
      solo_admin: "Solo un administrador registra cobros",
      errores: {
        importe: "Indica el importe cobrado (mayor que 0)",
        importe_total: "El importe total no puede ser negativo",
        fecha: "Indica la fecha de cobro",
      },
    },
    mover: {
      titulo: "Mover a «%{etapa}»",
      fecha_reunion: "Fecha y hora de la consultoría",
      fecha_presentacion: "Fecha y hora de la presentación (videollamada)",
      fecha_vuelta: "¿Cuándo volvemos a intentarlo?",
      ayuda_vuelta:
        "Ese día vuelve sola a la etapa desde la que se aparca (tras la presentación, a «Se lo tiene que pensar»).",
      mover: "Mover",
      falta_fecha: "Indica la fecha",
      importe_total: "Importe aceptado (€)",
      falta_importe: "Pon el importe por el que se ha aceptado",
    },
    pipeline: {
      titulo: "Pipeline",
      nueva_ficha: "Nueva ficha",
      ver_aparcados: "Ver aparcados",
      ocultar_aparcados: "Ocultar aparcados",
      movida: "Movida a «%{etapa}»",
      embudo: "Embudo",
      soltar_cobro: "Suelta aquí la tarjeta para registrar el cobro",
      vacio: "Sin fichas",
      total_valor: "%{valor} estimados",
      vencido: "Vencido",
    },
    agenda: {
      titulo: "Agenda",
      lista: "Lista",
      calendario: "Calendario",
      vencidos: "Vencidos",
      hoy: "Hoy",
      manana: "Mañana",
      semana: "Resto de la semana",
      despues: "Más adelante",
      vacio: "Nada en la agenda",
      cargando: "Cargando la agenda…",
      vacio_dia: "Nada este día",
      reunion: "Consultoría",
      presentacion: "Presentación",
      siguiente_paso: "Siguiente paso",
      vuelta: "Vuelve de Largo plazo",
      mes_anterior: "Mes anterior",
      mes_siguiente: "Mes siguiente",
      ir_hoy: "Hoy",
      anterior: "Anterior",
      siguiente: "Siguiente",
      vistas: "Vista de la agenda",
      vista_mes: "Mes",
      vista_semana: "Semana",
      vista_dia: "Día",
      vista_lista: "Lista",
      leyenda: "Color de cada responsable",
      mas: "+%{n} más",
      ver_lista: "Ver en la lista",
      elementos: "%{smart_count} elemento |||| %{smart_count} elementos",
    },
    // 41 (Robert, 23-24/10/2026): calendario de consultorías propio.
    agenda_propia: {
      cargando: "Buscando horas libres…",
      error: "No se han podido cargar las horas libres. Vuelve a intentarlo.",
      sin_huecos:
        "No hay horas libres en los próximos días. Avisa a Jan o Robert (quizá falta poner horarios).",
      ayuda_setter:
        "Solo salen las horas en las que alguien puede hacer la consultoría. Quién la hace lo decide el CRM.",
      elige_hora: "Elige una de las horas libres",
      agendada: "Consultoría agendada",
      cambiar_hora: "Cambiar la hora",
      guardar_hora: "Guardar la hora nueva",
      hora_cambiada: "Hora cambiada",
      reservas_sustituido:
        "Con el calendario propio encendido (abajo), el enlace de reservas ya no se usa.",
      titulo: "Calendario de consultorías",
      ayuda:
        "Encendido, sustituye al enlace de reservas: el setter elige una hora libre y el CRM decide quién la hace (primero Jan o Robert, el que menos lleve esa semana; si están ocupados, un consultor). La cita va al calendario de info@ con el consultor invitado, y el cliente recibe la invitación con el enlace de Meet en cuanto se agenda.",
      propia: "Calendario propio (sustituye al enlace de reservas)",
      duracionMin: "Duración de la consultoría",
      bloqueMin: "Tiempo que bloquea a quien la hace",
      pasoMin: "Cada cuánto se ofrece una hora",
      antelacionHoras: "Antelación mínima",
      dias: "Días que se ofrecen",
      unidad_minutos: "min",
      unidad_horas: "horas",
      unidad_dias: "días",
      quien: "Quién hace consultorías",
      franjas: "%{n} franjas de horario",
      sin_horario: "sin horario (no se le ofrecen consultorías)",
      calendario_por_defecto: "sin calendario personal",
      prioridad: "Quién va primero en el reparto",
      prioridad_admins: "Jan y Robert primero",
      prioridad_consultores: "Consultores primero",
      recordatorioHoras: "«Confirma la consultoría», si no está confirmada",
      horario_en_perfil:
        "Cada uno pone su horario y su calendario en su Perfil → «Mi horario de consultorías».",
      google: "Google (calendario de info@)",
      bien: "bien",
      revisar: "revisar",
      google_nunca: "Todavía sin conectar con Google.",
      citas_sin_calendario:
        "%{n} consultorías futuras aún sin cita en el calendario de info@.",
      sincronizar: "Sincronizar ahora",
      sincronizado: "Sincronizado con Google",
      google_sin_conectar:
        "Google aún no está conectado (falta el paso de info@)",
      mi_horario: "Mi horario de consultorías",
      mi_horario_ayuda:
        "Las franjas en las que puedes hacer consultorías. Lo que tengas en tu calendario de Google no se ofrecerá. Los «siguiente paso» no cuentan.",
      desde_dia: "Desde (%{dia})",
      hasta_dia: "Hasta (%{dia})",
      quitar_franja: "Quitar la franja",
      anadir_franja: "Franja",
      // 27/10/2026 (Robert): copiar las franjas de un día a los demás de una vez.
      copiar_a: "Copiar a…",
      copiar_dia: "Copiar las franjas del %{dia} a otros días",
      copiar_titulo: "Copiar las franjas del %{dia} a:",
      copiar_laborables: "Lunes a viernes",
      copiar_todos: "Todos",
      copiar_aplicar: "Aplicar",
      copiado: "Copiado. Pulsa «Guardar mi horario» para que valga.",
      mi_calendario: "Mi calendario de Google (correo)",
      mi_calendario_ayuda:
        "Compártelo con info@nevoraconsulting.com como «Ver solo libre/ocupado». Vacío = sin calendario personal: solo cuenta tu horario (y, para Jan y Robert, el calendario de info@).",
      guardar_horario: "Guardar mi horario",
      error_horario:
        "Revisa las franjas: cada una con la hora de inicio antes que la de fin.",
      guardado: "Horario guardado",
    },
    // 43 (Robert, 28/10/2026): las propuestas de colaboración de la web.
    colaboraciones: {
      titulo: "Colaboraciones de la web",
      ayuda:
        "Lo que llega por /colaboradores: aparte de la cola de ventas. «Pasar a ficha» si alguna acaba en cliente.",
      ninguna: "Todavía no ha llegado ninguna.",
      sin_base:
        "Las colaboraciones de la web llegan con la migración 43 (aún no está en la base).",
      estado_nueva: "Nueva",
      estado_vista: "Vista",
      estado_ficha: "En ficha",
      estado_descartada: "Descartada",
      pasar_a_ficha: "Pasar a ficha",
      ver_ficha: "Ver ficha",
      marcar_vista: "Vista",
      descartar: "Descartar",
      en_ficha: "Creada la ficha",
    },
    inicio: {
      eyebrow_admin: "Panel de dirección",
      eyebrow: "Tu panel",
      hola: "Hola, %{nombre}",
      cifras: "Cifras clave",
      anterior: "Periodo anterior",
      siguiente: "Periodo siguiente",
      sin_comparar: "Sin comparación",
      frente_anterior: "Frente al periodo anterior",
      vistas: {
        dia: "Hoy",
        semana: "Semana",
        mes: "Mes",
        trimestre: "Trimestre",
      },
      kpis: {
        llamadas: "Llamadas",
        gestionados: "Leads trabajados",
        citas: "Consultorías agendadas",
        realizadas: "Consultorías hechas",
        clientes: "Clientes nuevos",
        cobrado: "Cobrado",
        propuestas: "Propuestas",
        contestadas: "%{n} % contestadas",
        interesados: "%{n} % interesados",
        asistencia: "%{n} % asistencia",
        cierre: "%{n} % de cierre",
      },
      embudo: {
        titulo: "Embudo de los leads del periodo",
        ayuda:
          "De los leads que entraron en este periodo, cuántos llegaron a cada paso. El % es sobre el paso anterior.",
        vacio: "Ningún lead entró en este periodo.",
        se_pierde: "Donde más se pierde: %{paso}",
        pasos: {
          entrados: "Entrados",
          gestionados: "Trabajados",
          contactados: "Se habló con ellos",
          interesados: "Interesados",
          cita: "Consultoría agendada",
          realizada: "Consultoría hecha",
          propuesta: "Propuesta",
          cliente: "Cliente",
        },
      },
      alertas: {
        titulo: "Para mirar ahora",
        ayuda: "Lo que necesita a alguien hoy. Pulsa para ver las fichas.",
        vacio: "Todo al día.",
        tipos: {
          consultoria_sin_resultado: "Consultorías pasadas sin resultado",
          cita_sin_confirmar_48h: "Citas en menos de 48 h sin confirmar",
          sin_intento_24h: "Leads sin llamar en más de 24 h",
          paso_vencido: "Siguientes pasos vencidos",
          info_cliente_vencida: "Información del cliente que no ha llegado",
          aceptada_sin_cobro: "Aceptadas sin cobrar",
          sin_asignar: "Leads sin asignar",
        },
      },
      grafico: {
        titulo: "Actividad por día",
        llamadas: "Llamadas",
        contestadas: "Contestadas",
        sin_respuesta: "Sin respuesta",
        citas: "Consultorías agendadas",
        dia: "Día",
        ver_tabla: "Ver como tabla",
      },
      ranking: {
        titulo: "Equipo",
        persona: "Persona",
        llamadas: "Llamadas",
        contestadas: "Contestadas",
        citas: "Citas",
        hechas: "Hechas",
        clientes: "Clientes",
        vacio: "Sin actividad en este periodo.",
      },
      consultores: {
        titulo: "Consultores",
        persona: "Persona",
        hechas: "Hechas",
        asistencia: "Asistencia",
        clientes: "Clientes",
        cierre: "Cierre",
        vacio: "Ninguna consultoría hecha en este periodo.",
      },
      origenes: {
        titulo: "Calidad por origen",
        ayuda:
          "De cada origen, qué parte de los leads del periodo llega a hablar, a consultoría y a cliente. En gris, con menos de 20 leads (poco fiable).",
        origen: "Origen",
        entrados: "Leads",
        contactados: "Hablados",
        cita: "Consultoría",
        cliente: "Cliente",
        vacio: "Sin leads en este periodo.",
      },
      motivos: {
        titulo: "Por qué no les interesa",
        vacio: "Ningún lead perdido en este periodo.",
      },
      dinero: {
        titulo: "Dinero",
        firmado: "Firmado",
        cobrado: "Cobrado",
        pendiente_cobro: "Pendiente de cobro",
        comisiones_pendientes: "Comisiones por pagar",
      },
      // 47 (Robert, 31/10/2026): analítica del panel.
      fuente: {
        titulo: "Fuente de los datos",
        todas: "Todas las fuentes",
      },
      perdidas: {
        titulo: "Dónde se pierde y por qué",
        ayuda:
          "Fichas que pasaron a «No interesado» en el periodo, según dónde estaban y el motivo que se anotó.",
        momentos: {
          llamada: "En la llamada",
          consultoria: "Tras la consultoría",
          propuesta: "Tras la propuesta",
        },
        ninguna: "Ninguna",
        vacio: "Ninguna ficha perdida ni aparcada en este periodo.",
        largo_plazo: "Y %{n} a largo plazo:",
      },
      canales: {
        titulo: "Qué canal funciona",
        ayuda:
          "Cómo empezó la conversación con los leads del periodo y qué parte llega a hablar, a consultoría y a cliente. En gris, con menos de 20 leads (poco fiable).",
        canal: "Canal",
        vacio: "Sin leads en este periodo.",
        tipos: {
          web_reserva: "Web · reserva",
          web_llamada: "Web · te llamamos",
          web_formulario: "Web · formulario",
          llamada: "Llamada en frío",
          correo: "Correo",
          visita: "Visita",
          whatsapp: "WhatsApp",
          propio: "Contacto propio",
        },
      },
      sectores: {
        titulo: "Por sector",
        ayuda:
          "Qué sector convierte más (leads del periodo). En gris, con menos de 20 leads.",
        sector: "Sector",
        vacio: "Sin leads en este periodo.",
      },
      velocidad: {
        titulo: "Velocidad y esfuerzo",
        ayuda:
          "Cuánto se tarda en llamar, cuántas llamadas hacen falta (solo lo que no viene de la web) y cuántos días pasan entre pasos.",
        primer_web: "Primer contacto · web",
        primer_saliente: "Primer contacto · para llamar",
        por_contacto: "Llamadas para hablar con alguien",
        por_cita: "Llamadas por consultoría",
        por_cliente: "Llamadas por cliente",
        venta_media: "Venta media",
        de_leads: "Mediana de %{n}",
        sin_datos: "Sin datos aún",
        llamadas_total: "%{n} llamadas",
        citas_total: "%{n} consultorías",
        clientes_total: "%{n} clientes",
        ritmo: "Días entre pasos (mediana)",
        pasos: {
          cita: "Lead → consultoría agendada",
          realizada: "Agendada → hecha",
          propuesta: "Hecha → propuesta",
          cliente: "Propuesta → cliente",
        },
        ciclo: "Del lead al cliente: %{dias} (%{n} cerrados en el periodo).",
      },
      franjas: {
        titulo: "Mejor hora para llamar",
        ayuda:
          "Qué parte de las llamadas del periodo contesta, por día y hora. Cuanto más oscuro, más contestan.",
        vacio: "Ninguna llamada en este periodo.",
        mejor: "Donde más contestan: %{dia} a las %{hora} (%{pct} %).",
        dia: "Día",
        hora: "Hora",
        llamadas: "Llamadas",
        contestan: "Contestan",
        menos: "Menos",
        mas: "Más",
        pocos: "Menos de %{n} llamadas",
        ver_tabla: "Ver como tabla",
        ver_mapa: "Ver el mapa",
        celda: "%{dia}, %{hora}: %{n} llamadas, contestan el %{pct} %",
        celda_vacia: "%{dia}, %{hora}: sin llamadas",
        dias: {
          "1": "lunes",
          "2": "martes",
          "3": "miércoles",
          "4": "jueves",
          "5": "viernes",
          "6": "sábado",
          "7": "domingo",
        },
        dias_corto: {
          "1": "L",
          "2": "M",
          "3": "X",
          "4": "J",
          "5": "V",
          "6": "S",
          "7": "D",
        },
      },
      prevision: {
        titulo: "Previsión",
        ayuda:
          "Lo que probablemente entrará de los proyectos abiertos: el importe de cada uno por la probabilidad de su etapa.",
        ponderado: "Previsto",
        abierto: "Total abierto",
        etapa: "Etapa",
        proyectos: "Proyectos",
        importe: "Importe",
        probabilidad: "Probabilidad",
        previsto: "Previsto",
        vacio: "Ningún proyecto abierto con consultoría o propuesta.",
        sin_importe: "%{n} sin importe (no cuentan).",
        cambiar: "Cambiar las probabilidades",
      },
      objetivos: {
        titulo: "Objetivos del mes",
        ayuda:
          "Cómo vais frente al objetivo. La raya marca dónde habría que estar hoy para llegar a fin de mes.",
        llamadas: "Llamadas",
        citas: "Consultorías agendadas",
        clientes: "Clientes nuevos",
        cobrado: "Cobrado",
        a_ritmo: "A ritmo",
        por_debajo: "Por debajo",
        detalle: "%{pct} % del objetivo · ha pasado el %{mes} % del mes",
        poner: "Poner los objetivos del mes (Equipo)",
      },
    },
    // Guía paso a paso de cada papel (Robert, 02/11/2026).
    guia: {
      ver: "Ver guía",
      paso: "Paso %{n} de %{total}",
      saltar: "Saltar la guía",
      atras: "Atrás",
      siguiente: "Siguiente",
      terminar: "Terminar",
      que_guia: "¿Qué guía quieres ver?",
      de_setter: "Guía del setter",
      de_consultor: "Guía del consultor",
      bienvenida: {
        titulo: "Te damos la bienvenida a Nevora CRM",
        texto_setter:
          "En dos minutos te enseñamos dónde están tus leads, cómo anotar cada llamada y cómo agendar una consultoría. La puedes volver a ver cuando quieras desde «Ver guía», en Inicio.",
        texto_consultor:
          "En dos minutos te enseñamos dónde están tus consultorías, cómo prepararlas y cómo marcar cómo fueron. La puedes volver a ver cuando quieras desde «Ver guía», en Inicio.",
        ahora_no: "Ahora no",
      },
      ilustracion: {
        he_llamado: "He llamado",
        he_escrito: "He escrito",
        he_visitado: "He visitado",
        quiere_reunion: "Quiere reunión",
        interesado: "Interesado",
        ni_si_ni_no: "Ni sí ni no",
        no_contesta: "No contesta",
        mas_adelante: "Más adelante",
        no_interesa: "No le interesa",
        se_hizo: "Se hizo",
        no_se_presento: "No se presentó",
        notas: "Notas",
      },
      setter: {
        bienvenida: {
          titulo: "Así trabajas en Nevora CRM",
          texto:
            "Tu trabajo: llamar a los leads que te tocan, anotar qué ha pasado en cada llamada y agendar consultorías con quien quiera saber más.\n\nTe enseñamos cada pantalla en orden. Usa «Siguiente» o las flechas del teclado.",
        },
        inicio: {
          titulo: "Inicio: cómo vas",
          texto:
            "Tus cifras del periodo: llamadas, leads trabajados, consultorías agendadas y hechas, y clientes. Cada una se compara con el periodo anterior. Arriba eliges hoy, semana, mes o trimestre.\n\nSi Jan y Robert te ponen un objetivo del mes, aquí verás si vas a ritmo.",
        },
        alertas: {
          titulo: "Para mirar ahora",
          texto:
            "Lo que necesita tu atención hoy: leads que llevan más de un día sin llamar, siguientes pasos vencidos o consultorías sin confirmar. Pulsa una línea para ver esas fichas.",
        },
        leads: {
          titulo: "Leads: tu lista de llamadas",
          texto:
            "Ya viene ordenada para que empieces siempre por arriba: primero lo que llegó por la web, después los reintentos que ya tocan y luego los nuevos, por prioridad.\n\n«Próximo intento» te dice cuándo volver a llamar a quien no contestó.",
        },
        ficha: {
          titulo: "La ficha de cada lead",
          texto:
            "Pulsa un lead para abrir su ficha. Arriba ves en qué etapa está, quién lo lleva y cuál es el próximo paso.\n\nEn «Para llamar» tienes lo que sabemos del negocio (y el correo que ya se le envió, si lo hay) para abrir la llamada con algo concreto. A la derecha, todo el historial.",
        },
        resultado: {
          titulo: "Después de cada llamada",
          texto:
            "Pulsa «He llamado» (o «He escrito») y elige qué ha pasado:\n• Quiere reunión: agendas la consultoría con día y hora.\n• No contesta: el CRM programa solo el siguiente intento.\n• Más adelante o No le interesa: eliges el motivo, que nos sirve para mejorar.",
        },
        pipeline: {
          titulo: "Pipeline: tus fichas por etapa",
          texto:
            "Cada columna es una etapa. Las tarjetas sin siguiente paso salen marcadas para que no se te olvide ninguna. Si pasas una a «No interesado» o «Largo plazo», te pedirá el motivo.",
        },
        agenda: {
          titulo: "Agenda",
          texto:
            "Tus consultorías y siguientes pasos por día, semana o mes, también los reintentos de «No contesta». Pulsa cualquiera para abrir la ficha.",
        },
        buscar: {
          titulo: "Buscar una ficha",
          texto:
            "Encuentra cualquier negocio por nombre, teléfono o persona de contacto. En el ordenador, también con Ctrl + K.",
        },
        avisos: {
          titulo: "Avisos",
          texto:
            "La campana te avisa de lo importante: los leads que te asignan y cuando el cliente de una consultoría que agendaste pide otra hora. El número dice cuántos tienes sin leer.",
        },
        comisiones: {
          titulo: "Mis comisiones",
          texto:
            "Lo que llevas ganado de lo que ya se ha cobrado y lo estimado de las ventas aceptadas. En Inicio tienes también el resumen del mes.",
        },
        informes: {
          titulo: "Resumen de llamadas e Informe mensual",
          texto:
            "Cómo te va semana a semana y mes a mes: llamadas, cuántos contestan, consultorías, clientes y por qué se pierden. Úsalo para ver qué te funciona mejor.",
        },
        perfil: {
          titulo: "Tu perfil",
          texto:
            "Tu foto y «Avisos en este móvil», para que te lleguen las notificaciones al teléfono. Y si necesitas la guía otra vez, «Ver guía» está siempre en Inicio.",
        },
        final: {
          titulo: "Ya lo tienes",
          texto:
            "Empieza por el primer lead de la lista y anota cada llamada al colgar: así el CRM te ordena el día solo.\n\nPuedes volver a ver la guía cuando quieras con «Ver guía», en Inicio.",
        },
      },
      consultor: {
        bienvenida: {
          titulo: "Así trabajas en Nevora CRM",
          texto:
            "Tu trabajo: hacer las consultorías que agendan los setters y marcar cómo han ido para que Jan y Robert preparen la propuesta.\n\nTe enseñamos cada pantalla en orden. Usa «Siguiente» o las flechas del teclado.",
        },
        inicio: {
          titulo: "Inicio: tu mes",
          texto:
            "Tus consultorías hechas, la asistencia, los clientes que salen de ellas y tus comisiones del mes.",
        },
        agenda: {
          titulo: "Agenda: tus consultorías",
          texto:
            "Cada consultoría con su día y hora. Pulsa una para abrir la ficha del cliente.",
        },
        preparar: {
          titulo: "Antes de la consultoría",
          texto:
            "En la ficha tienes lo que sabemos del negocio («Para llamar»), las notas del setter y el historial de la conversación. Léelo antes de empezar.\n\nEl enlace de la videollamada (Meet) está en la ficha, listo para copiar.",
        },
        resultado: {
          titulo: "Al terminar",
          texto:
            "Marca «Se hizo» o «No se presentó». Con «Se hizo», la ficha pasa a Jan y Robert para preparar la propuesta y tú la sigues viendo. Añade en notas lo que hayas sacado: qué necesita, qué le preocupa y qué le has prometido.",
        },
        pipeline: {
          titulo: "Pipeline",
          texto:
            "Las fichas en las que haces la consultoría, por etapa, para ver en qué punto está cada cliente.",
        },
        horario: {
          titulo: "Tu horario",
          texto:
            "En Perfil → «Mi horario de consultorías» pones cuándo puedes hacerlas. Ahí activas también «Avisos en este móvil». Y si necesitas la guía otra vez, «Ver guía» está siempre en Inicio.",
        },
        avisos: {
          titulo: "Avisos",
          texto:
            "La campana te avisa cuando te toca una consultoría nueva y te recuerda confirmarla con el cliente unas horas antes si aún no está confirmada.",
        },
        comisiones: {
          titulo: "Mis comisiones",
          texto:
            "Lo que llevas ganado de lo cobrado de los clientes que salen de tus consultorías.",
        },
        final: {
          titulo: "Ya lo tienes",
          texto:
            "Mira la agenda cada mañana, prepara cada consultoría con la ficha y márcala al terminar.\n\nPuedes volver a ver la guía cuando quieras con «Ver guía», en Inicio.",
        },
      },
    },
    // 47: informe mes a mes.
    informe: {
      titulo: "Informe mensual",
      ayuda:
        "Cada mes, con sus propios leads (los que entraron ese mes y hasta dónde han llegado hoy) y la actividad del mes. La flecha compara con el mes anterior.",
      meses: "Últimos %{n} meses",
      descargar: "Descargar para Excel",
      en_curso: "(en curso)",
      // Informe de cierre de mes (Robert, 02/11/2026).
      cerrado_ayuda:
        "Mes cerrado, frente al mes anterior y a la media de los tres anteriores.",
      en_curso_ayuda:
        "Mes en curso: las cifras van a medias y no se comparan hasta que acabe.",
      mes_anterior: "Mes anterior",
      mes_siguiente: "Mes siguiente",
      resultados: "Resultados",
      actividad: "Actividad comercial",
      vs_anterior: "vs mes anterior",
      igual: "Igual que el mes anterior",
      media_tres: "Media 3 meses: %{valor}",
      ind: {
        clientes: "Clientes nuevos",
        firmado: "Firmado",
        cobrado: "Cobrado",
        venta_media: "Venta media",
        realizadas: "Consultorías hechas",
        cierre: "Tasa de cierre",
        cierre_detalle: "Clientes por cada consultoría hecha",
        ciclo: "Ciclo de venta",
        llamadas: "Llamadas",
        por_dia: "Llamadas por día",
        por_dia_detalle: "En %{n} días laborables",
        contacto: "Contestan",
        citas: "Consultorías agendadas",
        asistencia: "Asistencia",
        asistencia_detalle: "%{hechas} hechas, %{no} no se presentó",
        propuestas: "Propuestas presentadas",
      },
      conclusiones: {
        titulo: "Conclusiones del mes",
        pocos_datos:
          "Todavía hay pocos datos este mes para sacar conclusiones fiables.",
        tasa_sube: "%{que} sube del %{antes} % al %{ahora} %.",
        tasa_baja: "%{que} baja del %{antes} % al %{ahora} %.",
        recuento_sube: "%{que}: +%{pct} % frente al mes anterior.",
        recuento_baja: "%{que}: −%{pct} % frente al mes anterior.",
        que: {
          contacto: "La tasa de contacto de las llamadas",
          asistencia: "La asistencia a las consultorías",
          cierre: "La tasa de cierre",
          lead_a_cita: "El paso de lead a consultoría",
          clientes: "Clientes nuevos",
          realizadas: "Consultorías hechas",
          citas: "Consultorías agendadas",
          llamadas: "Llamadas",
          cobrado: "Cobrado",
        },
        se_pierde:
          "Donde más leads se quedan: de «%{desde}» a «%{paso}» solo pasa el %{pct} %.",
        pasos: {
          entrados: "Entrados",
          gestionados: "Trabajados",
          contactados: "Se habló con ellos",
          cita: "Consultoría agendada",
          realizada: "Consultoría hecha",
          propuesta: "Propuesta",
          cliente: "Cliente",
        },
        motivo: "Motivo principal de pérdida: «%{motivo}» (%{n} de %{total}).",
        canal:
          "El canal que mejor convierte: %{canal} (%{pct} % llega a consultoría).",
        franja: "Donde más contestan: %{dia} a las %{hora} (%{pct} %).",
      },
      embudo: {
        titulo: "Leads del mes",
        ayuda:
          "Los %{n} leads que entraron este mes y hasta dónde han llegado hoy. El % es sobre el paso anterior.",
      },
      canales_ayuda:
        "Cómo empezó la conversación con los leads del mes. En gris, con menos de 20 leads.",
      perdidas_ayuda:
        "Las %{n} fichas que se perdieron este mes, según dónde estaban y el motivo.",
      equipo: {
        titulo: "Equipo",
        ayuda:
          "Actividad y conversión de cada persona en el mes. Las consultorías y la asistencia, por quien las agendó; los clientes, por quien hizo la venta.",
        vacio: "Nadie tuvo actividad este mes.",
        persona: "Persona",
        llamadas: "Llamadas",
        por_dia: "Por día",
        contacto: "Contestan",
        agendadas: "Agendadas",
        hechas: "Hechas",
        asistencia: "Asistencia",
        clientes: "Clientes",
        cierre: "Cierre",
        consultores: "Quien hizo las consultorías",
      },
      tendencia: {
        titulo: "Tendencia de 12 meses",
        ayuda:
          "Cada cifra, mes a mes, hasta el mes elegido (en tinta llena). Pasa por encima de una barra para ver su valor.",
        ver_tabla: "Ver la tabla mes a mes",
        ocultar_tabla: "Ocultar la tabla",
        series: {
          entrados: "Leads",
          contacto: "Contestan",
          realizadas: "Consultorías hechas",
          clientes: "Clientes nuevos",
          cierre: "Tasa de cierre",
          cobrado: "Cobrado",
        },
      },
      vacio: "Todavía no hay datos.",
      no_disponible:
        "El informe mensual llega con la próxima actualización de la base de datos.",
      grupos: {
        leads: "Leads del mes",
        actividad: "Actividad del mes",
        dinero: "Dinero",
      },
      columnas: {
        mes: "Mes",
        entrados: "Leads",
        tasa_contacto: "% hablados",
        tasa_cita: "% consultoría",
        tasa_cliente: "% cliente",
        cliente: "Clientes",
        llamadas: "Llamadas",
        contestadas: "Contestadas",
        citas: "Consultorías agendadas",
        realizadas: "Consultorías hechas",
        no_shows: "No se presentó",
        clientes: "Clientes nuevos",
        perdidos: "Perdidos",
        motivo_principal: "Motivo principal",
        dias_ciclo: "Días hasta cerrar",
        firmado: "Firmado",
        cobrado: "Cobrado",
        venta_media: "Venta media",
      },
    },
    panel_direccion: {
      // 40 (Robert, 23/10/2026): en el Inicio de setters y consultores.
      comisiones: {
        titulo: "Tus comisiones de este mes",
        cobrada: "De lo cobrado",
        pagada: "Ya pagada",
        estimada: "Estimada (aceptadas)",
      },
      titulo: "Panel de dirección",
      titulo_setter: "Tu panel",
      por_etapa: "Ventas por etapa",
      clientes: "Clientes en curso",
      por_origen: "Por origen",
      por_asignado: "Por asignado",
      hoy: "Siguientes pasos de hoy",
      semana: "Esta semana",
      en_rojo: "Fichas en rojo",
      nada_hoy: "Nada para hoy",
      nada_semana: "Nada más esta semana",
      sin_rojo: "Ninguna ficha en rojo",
      motivos: "Por qué no les interesa",
      sin_motivos: "Todavía nadie ha dicho que no",
      sin_motivo: "Sin motivo anotado",
      total: "%{smart_count} ficha |||| %{smart_count} fichas",
      ver_todas: "Ver todas",
      leads_pendientes: "Leads pendientes",
      reuniones: "Consultorías y presentaciones",
      valor_pipeline: "Valor en el tablero",
      sin_fichas: "Todavía no hay fichas. Crea la primera o importa un CSV.",
    },
    usuarios: {
      papel: "Papel en el equipo",
      papeles: {
        setter: "Setter",
        consultor: "Consultor",
        ninguno: "Sin papel",
      },
      recibe_leads: "Recibe leads del reparto",
      pct_reparto: "% del reparto",
      tope: "Tope de pendientes",
      comision: "Comisión (%)",
      papel_ayuda:
        "Vacío = lo de Ajustes. Se puede cambiar después en Equipo. El consultor no recibe leads: solo hace consultorías.",
      papel_error:
        "El usuario está creado, pero su papel no se ha guardado: ponlo en Equipo.",
      titulo: "Usuarios",
      ayuda:
        "Quién puede entrar en Nevora CRM. Cada comercial ve solo sus fichas; los administradores ven todas. El papel en el equipo se pone al invitar y se cambia después en Equipo.",
      nuevo: "Nuevo usuario",
      cargando: "Cargando usuarios…",
      tu: "tú",
      administrador: "Administrador",
      comercial: "Comercial",
      desactivado: "Desactivado",
      activo: "Activo",
      ultimo_acceso: "Último acceso",
      nunca: "nunca",
      editar: "Editar",
      editar_titulo: "Editar usuario",
      alta_ayuda: "Nombre, email y cómo entrará la primera vez.",
      nombre: "Nombre",
      apellidos: "Apellidos",
      email: "Email",
      acceso: "Primer acceso",
      acceso_contrasena:
        "Contraseña provisional (se la pasas tú; no se envía correo)",
      acceso_invitacion:
        "Invitación por email (recibe un correo y elige su contraseña)",
      contrasena_provisional: "Contraseña provisional",
      contrasena_ayuda:
        "Mínimo 8 caracteres. Pásasela por un canal seguro (WhatsApp o en persona); podrá cambiarla con «He olvidado mi contraseña».",
      invitacion_ayuda:
        "Recibirá «Tu acceso a Nevora CRM» desde info@nevoraconsulting.com y elegirá su contraseña. Si no le llega en unos minutos, que mire en el spam.",
      desactivar_ayuda:
        "Un usuario desactivado no puede entrar ni aparece para asignar fichas. Sus fichas y su historial se conservan.",
      uno_mismo_ayuda:
        "No puedes quitarte tu propio acceso de administrador ni desactivarte.",
      crear: "Crear usuario",
      guardar: "Guardar",
      creado: "Usuario %{email} creado con contraseña provisional",
      invitado: "Invitación enviada a %{email}",
      guardado: "Usuario guardado",
      // 30 (Robert, 09–16/10/2026): email, borrar sin datos y foto de perfil.
      cambiar_email: "Cambiar el email",
      email_nuevo: "Email nuevo",
      email_repetido: "Repite el email nuevo",
      email_ayuda:
        "Vale al momento: desde ahora entrará con el email nuevo. Déjalo vacío para no cambiarlo.",
      borrar: "Borrar usuario",
      borrar_confirmar:
        "¿Borrar a %{nombre}? Solo se puede si no tiene nada asociado; queda apuntado en el registro de borrados.",
      borrado: "Usuario borrado",
      no_se_puede_borrar:
        "No se puede borrar: tiene datos asociados. Desactívalo en su lugar (no entra y se conserva su historial).",
      desactivar_en_su_lugar: "Desactivar en su lugar",
      desactivado_hecho: "Usuario desactivado",
      foto: "Foto de perfil",
      foto_ayuda:
        "JPG, PNG o WebP. Se recorta en cuadrado y se reduce antes de subirla.",
      cambiar_foto: "Cambiar la foto",
      quitar_foto: "Quitar la foto",
      foto_guardada: "Foto guardada",
      foto_quitada: "Foto quitada",
      asociado: {
        fichas_asignadas:
          "%{smart_count} ficha asignada |||| %{smart_count} fichas asignadas",
        fichas_creadas:
          "%{smart_count} ficha creada |||| %{smart_count} fichas creadas",
        notas: "%{smart_count} nota |||| %{smart_count} notas",
        proyectos: "%{smart_count} proyecto |||| %{smart_count} proyectos",
        asignaciones:
          "%{smart_count} asignación |||| %{smart_count} asignaciones",
        cobros:
          "%{smart_count} cobro o comisión |||| %{smart_count} cobros o comisiones",
        equipo:
          "%{smart_count} persona de su equipo |||| %{smart_count} personas de su equipo",
        fichas_borradas:
          "%{smart_count} ficha borrada por él |||| %{smart_count} fichas borradas por él",
        peticiones_leads:
          "%{smart_count} petición de leads |||| %{smart_count} peticiones de leads",
      },
      errores: {
        falta_nombre: "Escribe el nombre",
        email: "Email no válido",
        contrasena_corta:
          "La contraseña provisional necesita al menos 8 caracteres",
        quitarse_admin: "No puedes quitarte tu propio acceso de administrador",
        desactivarse: "No puedes desactivarte a ti mismo",
        ultimo_admin: "Tiene que quedar al menos un administrador activo",
        email_usado: "Ya hay un usuario con ese email",
        sin_correo:
          "No se ha podido enviar la invitación por correo. Prueba de nuevo en unos minutos o usa una contraseña provisional.",
        desconocido: "No se ha podido guardar el usuario",
        email_igual: "Es el mismo email que ya tiene",
        email_no_coincide: "Los dos emails no coinciden",
        tiene_datos: "Tiene datos asociados: desactívalo en vez de borrarlo",
        borrarse: "No puedes borrarte a ti mismo",
        no_borrable:
          "No se puede borrar: tiene que quedar al menos un administrador activo",
        foto: "No se ha podido guardar la foto",
      },
    },
    ajustes: {
      titulo: "Ajustes",
      // Barra lateral (Robert, 02/11/2026).
      grupos: {
        ventas: "Ventas",
        listas: "Listas",
        sistema: "Sistema",
      },
      nav: {
        general: "General",
        reparto: "Reparto de leads",
        consultorias: "Consultorías",
        comisiones: "Comisiones",
        prevision: "Previsión",
        sectores: "Sectores",
        motivos: "Motivos de pérdida",
        usuarios: "Usuarios",
        etapas: "Etapas",
      },
      descripciones: {
        general:
          "Cuándo una ficha se ve sin contacto (semáforo) y cuántas veces se insiste antes de aparcarla.",
        reparto:
          "Cómo llegan y se reparten los leads: tope por setter, cuándo se retiran, lo que entrega Nevora Prospect y el dueño de los de la web.",
        consultorias:
          "Agenda de consultorías, avisos antes de cada cita, calendario propio y a quién pasa la ficha cuando se hace.",
        comisiones:
          "Porcentaje por defecto de setters y consultores. El de cada persona se cambia en Equipo.",
        prevision:
          "Probabilidad de cierre de cada etapa para la previsión del Inicio.",
        sectores:
          "Los sectores que se eligen en cada ficha. Salen en este orden y el Inicio compara cómo convierte cada uno.",
        motivos:
          "Se elige uno cada vez que una ficha se pierde o pasa a «Largo plazo», de la lista que toca según dónde estaba. El Inicio cuenta dónde se pierde y por qué. Deja «Otro» al final para lo que no encaje.",
        usuarios: "Quién entra en el CRM y con qué permisos.",
        etapas: "Las etapas del embudo y quién mueve cada una (solo lectura).",
      },
      lista: {
        anadir_motivo: "Añadir motivo",
        nuevo_motivo: "Nuevo motivo…",
        anadir_sector: "Añadir sector",
        nuevo_sector: "Nuevo sector…",
        subir: "Subir «%{valor}»",
        bajar: "Bajar «%{valor}»",
        editar: "Renombrar «%{valor}»",
        renombrar: "Nuevo nombre de «%{valor}»",
        quitar: "Quitar «%{valor}»",
        guardar_cambio: "Guardar el nombre",
        cancelar: "Cancelar",
        repetido: "«%{valor}» ya está en la lista",
        vacia: "La lista está vacía: se usarán los valores por defecto.",
      },
      semaforo: "Semáforo (días desde el último contacto)",
      semaforo_ayuda:
        "Verde hasta N días, azul hasta N, amarillo hasta N, naranja hasta N; después, rojo.",
      verde: "Verde hasta",
      azul: "Azul hasta",
      amarillo: "Amarillo hasta",
      naranja: "Naranja hasta",
      dias: "días",
      minutos: "minutos",
      push_minutos: "Notificación antes de cada cita con hora",
      web: "Formulario de la web",
      web_ayuda:
        "Los leads del formulario de la web entran en «Lead nuevo» con este dueño. Si ya estaban en el CRM, se añade una nota a su ficha. Jan y Robert reciben el aviso.",
      responsable_web: "Dueño de los leads de la web",
      // 37 (Robert, 22/10/2026)
      consultoria: "Consultorías",
      consultoria_ayuda:
        "Al quedar hecha una consultoría, la ficha pasa al primero que la hizo que no sea consultor (Jan o Robert). Si la hizo solo un consultor, pasa a esta persona; el consultor la sigue viendo sin poder tocarla.",
      responsable_consultoria: "Dueño si la hizo solo un consultor",
      responsable_consultoria_defecto:
        "El de la web (o el primer administrador)",
      sin_responsable: "Sin dueño (quedan en «Sin asignar»)",
      max_intentos: "Intentos de «No contesta» antes de aparcar",
      sectores: "Sectores (uno por línea)",
      guardar: "Guardar ajustes",
      guardado: "Ajustes guardados",
      error_umbrales: "Los umbrales deben ser números enteros y crecientes",
      error_guardar: "No se han podido guardar los ajustes",
      solo_admin: "Solo los administradores pueden cambiar los ajustes",
      general: "General",
      usuarios: "Usuarios",
      motivos: "Motivos de pérdida",
      etapas: "Etapas",
      sectores_lista: "Sectores",
      sectores_ayuda:
        "Salen en el desplegable de sector de las fichas. También se crean desde la ficha con «+ Crear sector…».",
      motivos_lista: "En la llamada, antes de la consultoría",
      motivos_consultoria: "Tras la consultoría, sin propuesta todavía",
      motivos_propuesta: "Tras la propuesta",
      motivos_ayuda:
        "Se elige uno cada vez que una ficha se pierde o pasa a «Largo plazo», de la lista que toca según dónde estaba. El Inicio cuenta dónde se pierde y por qué. Deja «Otro» al final para lo que no encaje.",
      prevision: "Previsión",
      prevision_ayuda:
        "Probabilidad de cerrar una propuesta según su etapa. El Inicio multiplica el importe de cada proyecto abierto (el aceptado o, si no, el estimado) por esta probabilidad para calcular lo que probablemente entrará.",
      error_probabilidad: "Cada probabilidad tiene que estar entre 0 y 100 %",
      reparto: "Reparto y agenda",
      comisiones: "Comisiones",
      reparto_ayuda:
        "El reparto automático (cada 15 minutos) da los leads que entrega Nevora Prospect a los setters que reciben leads, según su % de Equipo. Lo de cada persona va en Equipo.",
      tope_pendientes: "Máximo de leads pendientes por setter",
      leads: "leads",
      dias_recuperacion: "Días sin contacto antes de retirar un lead",
      agenda: "Consultorías (agenda de Jan y Robert)",
      tope_consultorias: "Consultorías por semana antes de avisar",
      prospect: "Leads de Nevora Prospect",
      prospect_ayuda:
        "Prospect solo entrega leads mientras «Sin asignar» tenga menos de este número. Los que pasen más días de estos sin repartir quedan fríos: el setter no abre la llamada con el correo.",
      limite_sin_asignar:
        "Máximo en «Sin asignar» para que Prospect entregue más",
      dias_frio: "Días sin repartir para que un lead quede frío",
      reservas_url: "Página de reservas «Diagnóstico NEVORA»",
      reservas_ayuda:
        "El enlace de Google Calendar (30 min). Sale en la hoja «Quiere reunión» para que el setter elija hueco con el cliente.",
      comisiones_ayuda:
        "Porcentaje de la base imponible sin IVA de cada cobro para quien agendó la consultoría. Se puede cambiar por persona en Equipo. El mantenimiento nunca lleva comisión.",
      comision_global: "Comisión de los setters",
      comision_consultor: "Comisión de los consultores",
      por_ciento: "%",
      error_comision: "La comisión tiene que estar entre 0 y 100 %",
      error_reservas: "El enlace de reservas tiene que empezar por https://",
    },
    // Nivel de interés (28d, Robert 15/10/2026).
    interes: {
      titulo: "Nivel de interés",
      opcional: "Nivel de interés (opcional)",
      frio: "Frío",
      tibio: "Tibio",
      caliente: "Caliente",
      sin_nivel: "Sin nivel",
      quitar: "Quitar el nivel",
      cambiar: "Nivel de interés: %{nivel}. Toca para cambiarlo",
      caliente_auto: "Queda en «Caliente»",
      solo_calientes: "Solo calientes / interesados",
      guardado: "Nivel de interés guardado",
      error: "No se pudo guardar el nivel de interés",
    },
    // Notificaciones push en el móvil (33, Robert 16/10/2026).
    avisos_movil: {
      titulo: "Avisos en este móvil",
      ayuda:
        "Notificaciones de la app: unos minutos antes de cada cita con hora, el resumen de las 8:30 (de lunes a viernes) y los avisos de la campana. Se activan en cada móvil.",
      activar: "Activar en este móvil",
      activadas: "Notificaciones activadas en este móvil",
      desactivar: "Desactivar en este móvil",
      desactivadas: "Notificaciones desactivadas en este móvil",
      este_activo: "Este móvil recibe los avisos.",
      prueba: "Mandarme una de prueba",
      prueba_enviada:
        "Enviada a %{smart_count} móvil |||| Enviada a %{smart_count} móviles",
      permiso_denegado:
        "Sin permiso no hay notificaciones. Puedes darlo en los ajustes del móvil.",
      bloqueadas:
        "Las notificaciones están bloqueadas para Nevora CRM. En iPhone: Ajustes → Notificaciones → Nevora CRM. En Android: ajustes de Chrome o de la app → Notificaciones.",
      no_puede:
        "Este navegador no puede recibir notificaciones. En Android, usa Chrome; en iPhone, la app instalada.",
      iphone_1: "En Safari, toca Compartir (el cuadrado con la flecha).",
      iphone_2: "Elige «Añadir a pantalla de inicio».",
      iphone_3:
        "Abre Nevora CRM desde el icono nuevo y vuelve aquí: Perfil → Avisos en este móvil.",
      error: "No se han podido cambiar las notificaciones. Inténtalo otra vez.",
      mis_moviles: "Mis móviles con avisos",
      este: "este",
      aparato: "Aparato",
      desde: "Activado el %{fecha}",
      ultimo_envio: "Último aviso: %{fecha}",
      quitar: "Quitar",
    },
    // Resumen de llamadas (28d, Robert 15/10/2026).
    resumen: {
      // 40 (Robert, 23/10/2026): tarjetas por persona.
      equipo: "Todo el equipo",
      quieren_reunion: "Quieren reunión",
      ver_tabla: "Ver la tabla completa",
      sin_llamadas: "Sin llamadas en este periodo",
      titulo: "Resumen de llamadas",
      ayuda:
        "Llamadas registradas con «He llamado» y cuántas de cada resultado. Cuenta quién llamó, aunque la ficha la lleve hoy otra persona.",
      ayuda_setter:
        "Tus llamadas registradas con «He llamado» y cuántas de cada resultado.",
      dia: "Día",
      semana: "Semana",
      mes: "Mes",
      vistas: "Periodo del resumen",
      anterior: "Anterior",
      siguiente: "Siguiente",
      hoy: "Hoy",
      esta_semana: "Esta semana",
      este_mes: "Este mes",
      persona: "Persona",
      llamadas: "Llamadas",
      // Robert, 22/10/2026: además del % sobre todas, el % sobre las contestadas.
      contestadas: "Contestadas",
      leyenda:
        "Debajo de cada número: «del total», sobre todas las llamadas; «de contestadas», sobre aquellas en las que hablamos con la persona (todas menos «No contesta» y «No se presentó»). Solo cuenta «He llamado»: las visitas no entran.",
      pct_total: "%{pct} % del total",
      pct_contestadas: "%{pct} % de contestadas",
      sin_resultado: "Sin resultado",
      total: "Total",
      vacio: "Ninguna llamada en este periodo",
      cargando: "Cargando el resumen…",
      no_disponible: "El resumen llega con la próxima actualización",
      error: "No se pudo cargar el resumen",
    },
    // Marca «Interesado, falta confirmar fecha» (28c, 13/10/2026).
    interesado: {
      marca: "Interesado",
      ayuda:
        "Interesado desde el %{fecha}: falta confirmar la fecha de la consultoría",
    },
    // «Añadir a Google Calendar» (Robert, 14/10/2026): abre Google Calendar con la cita rellenada.
    google_calendar: {
      siguiente: "Siguiente paso a Google Calendar",
      consultoria: "Consultoría a Google Calendar",
      presentacion: "Presentación a Google Calendar",
    },
    // «Abrir SDR» (Jan y Robert, 13/10/2026): texto para el chat que prepara la consultoría.
    sdr: {
      boton: "Abrir SDR",
      ayuda:
        "Copia el texto para abrir el chat «SDR - contacto - negocio» y preparar la consultoría",
      copiado: "Copiado. Abre un chat nuevo «%{titulo}» y pega el texto.",
      error_copiar:
        "No se ha podido copiar al portapapeles. Inténtalo de nuevo desde el ordenador.",
      sin_contacto: "Sin contacto",
      intro: "Prepara la consultoría con este negocio. Tareas:",
      tarea_core:
        "Abre (o crea) la ficha de %{contacto} en el Core de Nevora con lo que hay aquí.",
      tarea_sdr: "Prepara la consultoría con sdr-research en modo discovery.",
      consultoria: "Consultoría",
      fecha_hora: "Fecha y hora",
      agendada_por: "La agendó",
      negocio: "Negocio",
      nombre: "Nombre",
      sector: "Sector",
      municipio: "Municipio",
      direccion: "Dirección",
      web: "Web",
      maps: "Google Maps",
      contacto: "Contacto",
      persona: "Persona",
      email: "Email",
      telefonos: "Teléfonos",
      prospect: "Lo que manda Nevora Prospect",
      resumen: "Resumen para abrir la llamada",
      caso: "Caso que encaja",
      analisis: "Análisis de su web",
      del_sector: "¿Es del sector?",
      senales: "Señales",
      hechos: "Lo que dice su web",
      notas: "Notas de las llamadas (de la más antigua a la más reciente)",
      sin_notas: "Sin notas",
      objecion: "Objeción",
      cambio_etapa: "Cambio de etapa",
    },
    para_llamar: {
      titulo: "Para llamar",
      prioridad: "Prioridad %{n}",
      prioridad_ayuda:
        "Prioridad que le da Nevora Prospect: 1 = llamar primero",
      prioridad_1: "Nombre y móvil del dueño",
      prioridad_2: "Nombre del dueño y teléfono",
      prioridad_3: "Solo el teléfono del negocio",
      tipos: {
        email_sin_respuesta: "Email sin respuesta",
        sin_email: "Sin email (directo a llamada)",
        solo_llamadas: "Campaña de llamadas",
        frio_sin_analisis: "Frío sin análisis",
      },
      correo_cabecera: "Correo enviado el día %{fecha} desde el buzón %{buzon}",
      correo_cabecera_sin_buzon: "Correo enviado el día %{fecha}",
      frio: "Correo antiguo",
      plegado: "Lo que mandó Prospect (correo, web y capturas)",
      frio_ayuda:
        "Pasó más de %{dias} días sin repartir: el correo queda lejos, mejor no mencionarlo al llamar.",
      no_abrir_correo: "No menciones el correo",
      // 39 (Robert, 23/10/2026): en vez del tachado, por qué.
      no_mencionar_correo:
        "En la llamada no menciones el correo: se lo enviamos el %{fecha} y ya no lo recordará. Preséntate como si fuera la primera vez.",
      no_abrir_correo_ayuda:
        "Hace más de %{dias} días del primer correo: queda lejos, mejor no mencionarlo al llamar.",
      firmado_por: "firmado por %{quien}",
      donde: "Dónde",
      dueno: "Dueño",
      fuente: "fuente",
      fuente_web: "su web",
      fuente_borme: "BORME",
      confianza_alta: "lo dice la fuente",
      confianza_media: "deducido",
      ver_fuente: "ver fuente",
      telefonos: "Teléfonos",
      tipo_movil: "Móvil",
      tipo_fijo: "Fijo",
      de_dueno_confirmado: "Del dueño (confirmado)",
      de_dueno_probable: "Del dueño (probable)",
      de_negocio: "Del negocio",
      email: "Email público",
      email_publico: "público en su web (%{fecha})",
      sin_email: "No publica email",
      resumen: "Resumen para abrir la llamada",
      caso: "Caso que encaja",
      correo_enviado: "Correo enviado",
      email_nevora: "Nevora le escribió el %{fecha}",
      sin_correos: "No se le ha escrito (no publica email)",
      // Robert, 12/10/2026: si tiene email público, no es que no se le pueda escribir.
      sin_correos_con_email: "Todavía no se le ha escrito",
      n_correos: "%{smart_count} correo |||| %{smart_count} correos",
      con_recordatorio: "hubo recordatorio (%{fecha})",
      sin_recordatorio: "sin recordatorio",
      correo: "Correo",
      correo_toque_1: "Primer correo",
      correo_toque_2: "Segundo correo",
      correo_toque_3: "Tercer correo",
      correo_recordatorio: "Recordatorio",
      correo_manual: "Escrito a mano",
      desde: "desde %{buzon}",
      asunto: "Asunto",
      enviado_a: "Enviado a %{destino}",
      analisis: "Análisis de su web",
      sector: "Sector",
      sector_si: "del sector",
      sector_no: "no es del sector",
      sector_dudoso: "dudoso",
      hechos:
        "Lo que dice su web (%{smart_count} dato) |||| Lo que dice su web (%{smart_count} datos)",
      dato_confirmado: "confirmado",
      dato_estimado: "estimado",
      capturas: "Capturas de su web",
      captura_portada: "Portada",
      captura_contacto: "Contacto",
      capturas_no_disponibles:
        "Las capturas no están disponibles ahora. Vuelve a abrir la ficha más tarde.",
      web: "Web",
      maps: "Ver en Google Maps",
      instagram: "Instagram",
    },
    duplicados: {
      aviso_admin: "Posible duplicado: ya hay negocios con un nombre parecido",
      de: "de %{quien}",
      sin_asignar: "sin asignar",
      aviso_setter:
        "Hay %{smart_count} negocio con un nombre parecido en el CRM. Si es el mismo, consúltalo con Jan o Robert. |||| Hay %{smart_count} negocios con un nombre parecido en el CRM. Si es alguno de ellos, consúltalo con Jan o Robert.",
    },
    reservas: {
      abrir: "Elegir hueco en «Diagnóstico NEVORA»",
      sin_enlace:
        "Todavía no hay página de reservas en Ajustes. Acuerda la fecha con Jan y Robert y escríbela aquí.",
      contador: "Esta semana: %{n} de %{tope} consultorías",
      tope: "Esta semana ya hay %{n} consultorías (tope %{tope}). Mejor otra semana, o avisa a Jan y Robert.",
    },
    avisos: {
      ver_anteriores: "Ver anteriores (30 días)",
      ocultar_anteriores: "Ocultar anteriores",
      sin_anteriores: "No hay avisos leídos en los últimos 30 días.",
      titulo: "Avisos",
      sin_leer: "%{smart_count} sin leer |||| %{smart_count} sin leer",
      marcar_todos: "Marcar todo leído",
      vacio: "No tienes avisos nuevos",
    },
    equipo: {
      // 47 (Robert, 31/10/2026): objetivos del mes por persona.
      objetivos: {
        titulo: "Objetivos de %{mes}",
        persona: "Persona",
        llamadas: "Llamadas",
        citas: "Consultorías",
        clientes: "Clientes",
        cobrado: "Cobrado (€)",
        guardar: "Guardar objetivos",
        copiar_anterior: "Copiar los del mes anterior",
        guardados: "Objetivos guardados",
        ayuda:
          "Deja en blanco lo que no tenga objetivo. El Inicio enseña cómo va cada uno y el equipo (la suma). Cada setter ve los suyos; el cobrado solo lo ven Jan y Robert.",
        no_disponible:
          "Los objetivos llegan con la próxima actualización de la base de datos.",
      },
      titulo: "Equipo",
      ayuda:
        "El embudo de cada setter en el mes y su configuración. Una consultoría cuenta como realizada al sacar la tarjeta de «Consultoría agendada» hacia la propuesta, o hacia No interesado o Largo plazo si la reunión ya pasó.",
      mes: "Mes",
      embudo: "Embudo del mes",
      embudo_ayuda:
        "Llamadas: las que anota el setter. Citas: consultorías que agendó. No se presentó: citas suyas a las que el cliente no vino (nunca cuentan como hechas). Consultorías: las realizadas. Propuestas y cierres: de las ventas que son suyas. Cobros, cobrado (sin IVA) y comisión: por la fecha de cobro. Debajo de cada número, el % que pasa del paso anterior.",
      cargando: "Cargando el embudo…",
      // 40 (Robert, 23/10/2026): embudo visual y quien hace consultorías.
      todo_el_equipo: "Todo el equipo",
      de_las_citas: "%{pct} % de las citas",
      paso_flojo: "Donde más cae respecto al equipo: %{paso}",
      consultores: "Quien hace consultorías",
      consultores_ayuda:
        "Consultorías en las que la persona está marcada en «Quién hace la consultoría»: agendadas en el mes, hechas, «No se presentó», cierres que salen de ellas y su comisión de consultor (por la fecha de cobro). Informativo: el consultor no vende directamente. Jan y Robert cuentan cuando están marcados.",
      sin_consultorias: "Nadie marcado en una consultoría este mes.",
      c: {
        consultorias: "Consultorías",
        hechas: "Hechas",
        no_shows: "No se presentó",
        cierres: "Cierres",
        comision: "Comisión de consultor",
      },
      sin_setters:
        "Todavía nadie tiene rol comercial. Dáselo abajo, en Configuración.",
      persona: "Persona",
      m: {
        pendientes: "Pendientes",
        recuperados: "Retirados",
        llamadas: "Llamadas",
        interesados: "Interesados",
        citas: "Citas",
        consultorias: "Consultorías",
        propuestas: "Propuestas",
        cierres: "Cierres",
        cobros: "Cobros",
        cobrado: "Cobrado",
        comision: "Comisión",
        no_shows: "No se presentó",
      },
      configuracion: "Configuración",
      configuracion_ayuda:
        "Rol comercial, si recibe leads del reparto, su % del reparto, su máximo de pendientes y su comisión. Vacío = lo de Ajustes.",
      rol: "Rol comercial",
      roles: {
        ninguno: "Sin rol comercial",
        setter: "Setter",
        closer: "Closer",
        team_lead: "Team lead",
        consultor: "Consultor (solo consultorías)",
      },
      recibe_leads: "Recibe leads",
      porcentaje: "% del reparto",
      tope: "Máx. pendientes",
      comision: "Comisión %",
      team_lead: "Su team lead",
      sin_team_lead: "Sin team lead",
      guardar: "Guardar",
      guardado: "Datos comerciales guardados",
      error_numeros:
        "Revisa los números: % y comisión entre 0 y 100, máximo de pendientes 0 o más",
      suma_porcentajes:
        "Los % de quien recibe leads suman %{suma}. El reparto es proporcional, pero lo normal es que sumen 100.",
      filtro_persona: "Fichas de",
      todas_personas: "Todas las personas",
      n_personas: "%{smart_count} personas |||| %{smart_count} personas",
      solo_admin: "Esta pantalla es solo para Jan y Robert",
    },
    llamadas: {
      proximo_intento: "Próximo intento",
      llamar_ya: "Llamar ya",
      vencido: "Tocaba %{momento}",
      hoy: "Hoy",
      manana: "Mañana",
    },
    en_bloque: {
      quitar_dueno: "Devolver a Sin asignar",
      devueltos:
        "%{smart_count} ficha devuelta a Sin asignar |||| %{smart_count} fichas devueltas a Sin asignar",
      pasar_todo: "Pasar sus fichas a…",
      pasar_todo_ayuda:
        "Todas las fichas que lleva %{nombre} pasan a la persona que elijas (por ejemplo, si se va o está de baja).",
      pasar: "Pasar %{smart_count} ficha |||| Pasar %{smart_count} fichas",
      pasadas: "%{smart_count} ficha pasada |||| %{smart_count} fichas pasadas",
      sin_fichas: "No lleva ninguna ficha.",
    },
    sin_asignar: {
      titulo: "Sin asignar",
      ayuda:
        "Leads pendientes de llamar sin dueño: los que Prospect ha entregado y el reparto aún no ha colocado, los retirados por falta de contacto y los de un CSV sin asignar. Márcalos y elige a quién.",
      a_quien: "Asignar a…",
      asignar: "Asignar |||| Asignar %{smart_count}",
      asignados:
        "%{smart_count} lead asignado |||| %{smart_count} leads asignados",
      todos: "Marcar todos",
      desde: "Esperando desde",
      recuperado: "Retirado",
      vacio: "No hay leads sin asignar",
    },
    comisiones: {
      titulo: "Comisiones",
      ayuda:
        "La comisión de cada persona por cada cobro del mes: el setter que agendó (5 %) y el consultor que hizo la consultoría (10 %), sobre la base sin IVA. Qué pasa si hay devolución está por decidir: aquí no hay liquidaciones.",
      por_persona: "Por persona",
      papel: "Como",
      papeles: {
        setter: "setter",
        consultor: "consultor",
        closer: "closer",
        team_lead: "team lead",
      },
      cobros: "Cobros",
      base: "Base sin IVA",
      comision: "Comisión",
      total: "Total",
      cobros_mes: "Cobros del mes",
      sin_comisiones: "Ningún cobro de este mes ha generado comisión",
      sin_cobros: "No hay cobros este mes",
      del_cobro: "Comisión %{importe} (%{pct} %) para %{persona}",
      motivos: {
        mantenimiento: "Sin comisión: mantenimiento",
        sin_comercial: "Sin comisión: la consultoría no la agendó un setter",
        fuera_de_plazo: "Sin comisión: fuera del plazo de 6 meses",
      },
      // 36: Jan y Robert marcan cuándo se ha pagado la comisión de cada cobro.
      pagada: "Comisión pagada",
      pagada_el: "Pagada el %{fecha}",
      pendiente: "Pendiente de pagar",
      marcada_pagada: "Comisión marcada como pagada",
      desmarcada_pagada: "Comisión marcada como pendiente",
    },
    // 36: lo que ve un setter de sus ventas (Robert, 20/10/2026).
    mis_comisiones: {
      titulo: "Mis comisiones",
      ayuda:
        "Tus ventas desde «Aceptada» (las que agendaste o en las que hiciste la consultoría): la base firmada (sin IVA) y tu comisión estimada. Por cada cobro, el importe, tu comisión y si ya te la han pagado. Antes de «Aceptada» no hay importes.",
      mes: "Mes",
      ver_todo: "Ver todo",
      ver_mes: "Ver solo este mes",
      vacio_mes: "Este mes no tienes ventas aceptadas ni cobros.",
      cargando: "Cargando tus comisiones…",
      vacio: "Todavía no tienes ventas aceptadas.",
      base_firmada: "Base firmada",
      estimada: "Comisión estimada",
      aceptada_el: "Aceptada el %{fecha}",
      sin_cobros: "Aún sin cobros",
      cobro: "Cobro del %{fecha}",
      importe: "Importe",
      comision: "Tu comisión",
      total_estimada: "Comisión estimada",
      total_cobrada: "Comisión de lo cobrado",
      total_pagada: "Ya pagada",
    },
    importar: {
      titulo: "Importar negocios desde CSV",
      ayuda:
        "Sube un CSV con una fila por negocio. Solo la columna «nombre» es obligatoria. Descarga la plantilla para ver las columnas.",
      plantilla: "Descargar plantilla CSV",
      elegir: "Elegir fichero CSV",
      filas: "%{smart_count} fila leída |||| %{smart_count} filas leídas",
      vista_previa: "Vista previa (primeras %{n})",
      importar:
        "Importar %{smart_count} negocio |||| Importar %{smart_count} negocios",
      importando: "Importando… %{hechas} de %{total}",
      hecho: "Importación terminada: %{ok} creados, %{errores} errores",
      sin_nombre: "Sin nombre (se omite)",
      duplicado: "Teléfono ya existente en «%{nombre}»",
      duplicados_aviso:
        "%{smart_count} fila con teléfono ya existente (se importa igualmente, revísala) |||| %{smart_count} filas con teléfono ya existente (se importan igualmente, revísalas)",
      duplicados_web_aviso:
        "%{smart_count} fila con web ya existente en otra ficha (se importa igualmente, revísala) |||| %{smart_count} filas con web ya existente en otra ficha (se importan igualmente, revísalas)",
      columnas: "Columnas reconocidas: %{columnas}",
      columnas_ignoradas: "Columnas ignoradas: %{columnas}",
      error_csv: "No se ha podido leer el CSV",
      otra: "Importar otro fichero",
      ver_leads: "Ver los leads",
      solo_admin: "Solo los administradores pueden importar",
    },
  },
};
